import { AccountCompanyContactPerson } from './account-company-contact-person.model';
import { AccountCompanyAddress } from './account-company-address.model';
import { AccountCompanyDTO } from './dtos/account-company.dto';
import { AccountCompanyDetails } from './account-company-details.model';

export class AccountCompany {
  details: AccountCompanyDetails;
  contactPerson: AccountCompanyContactPerson;
  addressDetails: AccountCompanyAddress;

  prsQ1: string;
  prsQ2: string;
  prsQ3: string;

  static fromDto(dto: AccountCompanyDTO): AccountCompany {
    const company = new AccountCompany();

    company.details = {
      acCode: dto.acCode?.trim(),
      providerType: dto.providerType,
      name: dto.accountName?.trim(),
      officialName: dto.officialName?.trim(),
      organisationTypeId: +dto.orgType,
      organisationTypeString: dto.orgTypeString?.trim(),
      currentTradingName: dto.taName?.trim(),
      previousTradingName: dto.previousTAName?.trim(),
      registrationNumber: dto.regNo?.trim(),
      website: dto.website?.trim(),
      deliveryMethod: dto.deliveryMethod,
      languagePreference: dto.language,
      isMobileOperator: dto.isMobileOperator,
      isFixedOperator: dto.isFixedOperator

    };

    company.contactPerson = {
      salutation: dto.salutation?.trim(),
      firstName: dto.firstName?.trim(),
      lastName: dto.lastName?.trim(),
      nonCompany: dto.nonCompany
    };

    company.addressDetails = new AccountCompanyAddress();
    company.addressDetails.addressLine1 = dto.addressLine1?.trim();
    company.addressDetails.addressLine2 = dto.addressLine2?.trim();
    company.addressDetails.addressLine3 = dto.addressLine3?.trim();
    company.addressDetails.addressLine4 = dto.addressLine4?.trim();
    company.addressDetails.postCode = dto.postCode?.trim();
    company.addressDetails.country = dto.country?.trim();
    company.addressDetails.county = dto.county?.trim();

    company.addressDetails.regAddressLine1 = dto.regAddressLine1?.trim();
    company.addressDetails.regAddressLine2 = dto.regAddressLine2?.trim();
    company.addressDetails.regAddressLine3 = dto.regAddressLine3?.trim();
    company.addressDetails.regAddressLine4 = dto.regAddressLine4?.trim();
    company.addressDetails.regPostCode = dto.regPostCode?.trim();
    company.addressDetails.regCountry = dto.regCountry?.trim();
    company.addressDetails.regCounty = dto.regCounty?.trim();

    company.addressDetails.telephone = dto.phone?.trim();
    company.addressDetails.mobile = dto.mobile?.trim();
    company.addressDetails.fax = dto.fax?.trim();
    company.addressDetails.email = dto.adminEmail?.trim();

    company.prsQ1 = dto.prS_Q1;
    company.prsQ2 = dto.prS_Q2;
    company.prsQ3 = dto.prS_Q3;

    return company;
  }

  convertToDto(): AccountCompanyDTO {
    const dto: AccountCompanyDTO = {
      acCode: this.details.acCode?.trim(),
      providerType: +this.details.providerType,
      orgType: +this.details.organisationTypeId,
      orgTypeString: this.details.organisationTypeString?.trim(),
      previousTAName: this.details.previousTradingName?.trim(),
      website: this.details.website?.trim(),
      accountName: this.details.name?.trim(),
      officialName: this.details.officialName?.trim(),
      taName: this.details.currentTradingName?.trim(),
      regNo: this.details.registrationNumber?.trim(),

      lastName: this.contactPerson.lastName?.trim(),
      nonCompany: this.contactPerson.nonCompany,
      firstName: this.contactPerson.firstName?.trim(),
      salutation: this.contactPerson.salutation?.trim(),

      addressLine1: this.addressDetails.addressLine1?.trim(),
      addressLine2: this.addressDetails.addressLine2?.trim(),
      addressLine3: this.addressDetails.addressLine3?.trim(),
      addressLine4: this.addressDetails.addressLine4?.trim(),
      postCode: this.addressDetails.postCode?.trim(),
      county: this.addressDetails.county?.trim(),
      country: this.addressDetails.country?.trim(),

      regAddressLine1: this.addressDetails.regAddressLine1?.trim(),
      regAddressLine2: this.addressDetails.regAddressLine2?.trim(),
      regAddressLine3: this.addressDetails.regAddressLine3?.trim(),
      regAddressLine4: this.addressDetails.regAddressLine4?.trim(),
      regPostCode: this.addressDetails.regPostCode?.trim(),
      regCounty: this.addressDetails.regCounty?.trim(),
      regCountry: this.addressDetails.regCountry?.trim(),
      phone: this.addressDetails.telephone?.trim(),
      mobile: this.addressDetails.mobile?.trim(),
      fax: this.addressDetails.fax?.trim(),

      prS_Q1: this.prsQ1?.trim(),
      prS_Q2: this.prsQ2?.trim(),
      prS_Q3: this.prsQ3?.trim(),

      adminEmail: this.addressDetails.email?.trim(),

      deliveryMethod: this.details.deliveryMethod,
      language: this.details.languagePreference,
      isMobileOperator: this.details.isMobileOperator,
      isFixedOperator: this.details.isFixedOperator,
    };

    return dto;
  }

  getDeepCopy(): AccountCompany {
    const copy = new AccountCompany();
    copy.details = JSON.parse(JSON.stringify(this.details));
    copy.contactPerson = JSON.parse(JSON.stringify(this.contactPerson));
    copy.addressDetails = this.addressDetails.getDeepCopy();
    copy.prsQ1 = this.prsQ1;
    copy.prsQ2 = this.prsQ2;
    copy.prsQ3 = this.prsQ3;

    return copy;
  }
}
